import { useState } from 'react'
import { ChevronRight } from 'lucide-react'
import { cn } from '@/lib/utils'
import { NODE_TYPE_HELP } from './nodeTypeHelp'

/**
 * Always-available, collapsible legend for the four kinds of stock. Complements the
 * per-field hover tooltip so the definitions are discoverable without hovering
 * (useful in a demo). Collapsed by default to keep the footprint minimal.
 */
export default function NodeTypeLegend() {
  const [open, setOpen] = useState(false)
  return (
    <div>
      <button
        type='button'
        onClick={() => setOpen((o) => !o)}
        aria-expanded={open}
        className='flex items-center gap-1.5 text-sm font-medium text-dark-blue hover:underline dark:text-slate-300'
      >
        <ChevronRight
          className={cn(
            'h-4 w-4 transition-transform motion-reduce:transition-none',
            open && 'rotate-90'
          )}
        />
        What do the stock types mean?
      </button>
      {open && (
        <div className='mt-2 rounded-lg border bg-muted/40 p-3 text-sm text-muted-foreground'>
          {NODE_TYPE_HELP}
        </div>
      )}
    </div>
  )
}
